module.exports = __webpack_public_path__ + "img/client_download.5b71a9fb.png";